import React from "react"
import Badge from "./Badge"
import { Badge as BadgeType } from "@warp/types/product"
import { isMultipleBadge, isSingleBadge } from "./utils"

type PropType = {
  badges?: BadgeType[]
  variantId?: number
  filter?: "singleBadgesOnly" | "multipleBadgesOnly"
}

const Badges = ({ badges, variantId, filter }: PropType) => {
  if (!badges || badges.length === 0) return null

  const filteredBadges = React.useMemo(() => {
    let result = badges

    if (filter === "singleBadgesOnly") {
      result = badges.filter((badge) => isSingleBadge(badge))
    } else if (filter === "multipleBadgesOnly") {
      result = badges.filter((badge) => isMultipleBadge(badge))
    }

    return result
  }, [filter, badges])

  return (
    <>
      {filteredBadges.map((badge, index) => (
        <Badge badge={badge} variantId={variantId} key={index} />
      ))}
    </>
  )
}

export default Badges
